import { Button } from "@mui/material";
import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../../Config/baseUrl";

export default function AddProjectCategory() {
    const { state } = useLocation();
    const { type } = useParams();
    const [data, setData] = useState(null);
    const navigate = useNavigate();

    const getCategory = () => {
        axios
            .get(`${baseUrl}/blog/project-category-api/?projectcategory_id=${state}`, {
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                setData(res.data?.data || {});
            })
            .catch((err) => {
                console.error(err);
                toast.error(err.message);
            });
    };

    useEffect(() => {
        if (state) getCategory();
    }, [state]);

    const formik = useFormik({
        initialValues: {

            name: data?.name || "",
            images: null,
        },
        enableReinitialize: true,
        validate: (values) => {
            const errors = {};
            if (!values.name) errors.name = "Category name is required";
            if (type === "add" && !values.images) errors.images = "Image is required";
            return errors;
        },
        onSubmit: async (values) => {
            try {
                const formData = new FormData();
                formData.append("store", localStorage.getItem("store_id"));
                formData.append("name", values.name);
                if (values.images) formData.append("images", values.images);
                if (type === "update") formData.append("projectcategory_id", state);

                const config = {
                    headers: {
                        Authorization: `Token ${localStorage.getItem("token")}`,
                        "Content-Type": "multipart/form-data",
                    },
                };

                const response =
                    type === "add"
                        ? await axios.post(`${baseUrl}/blog/project-category-api/`, formData, config)
                        : await axios.patch(`${baseUrl}/blog/project-category-api/`, formData, config);

                if (response.data.response_code === 200) {
                    toast.success(response.data.message);
                    navigate(-1);
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                console.error(error);
                toast.error("Something went wrong!");
            }
        },
    });

    return (
        <div className="flex flex-col justify-center gap-5 py-4 lg:flex-row">
            <div className="flex flex-col justify-center w-full lg:w-3/5">
                <div className="mt-5 bg-white shadow-lg p-4 rounded-lg">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="flex flex-col gap-5">
                            {/* Category Name */}
                            <div>
                                <p className="p-1 text-sm font-semibold">Category Name</p>
                                <input
                                    id="name"
                                    placeholder="Enter name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    className="w-full p-2 px-4 border border-gray-300 rounded"
                                />
                                {formik.errors.name && formik.touched.name && (
                                    <p className="text-red-500 text-sm">{formik.errors.name}</p>
                                )}
                            </div>

                            {/* Image Upload */}
                            <div>
                                <p className="p-1 text-sm font-semibold">Image</p>
                                <input
                                    id="image"
                                    type="file"
                                    onChange={(event) =>
                                        formik.setFieldValue("images", event.target.files[0])
                                    }
                                    className="w-full p-2 px-4 border border-gray-300 rounded"
                                />
                                {formik.errors.images && formik.touched.images && (
                                    <p className="text-red-500 text-sm">{formik.errors.images}</p>
                                )}
                            </div>

                            {/* Submit Button */}
                            <div className="flex justify-center">
                                <Button
                                    type="submit"
                                    variant="contained"

                                >
                                    {type === "update" ? "Update" : "Add"}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
